import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InputFormField from './input-form-field';

class TextAreaFormField extends Component {

  render() {
    const {
      children,
      inputProps,
      rows,
      ...otherProps
    } = this.props;

    const attributes = {
      ...otherProps,
      inputProps: {
        ...inputProps,
        rows
      },
      inputTag: 'textarea',
      type: 'textarea-item'
    };

    return (
      <InputFormField {...attributes}>
        {children}
      </InputFormField>
    );
  }
}

TextAreaFormField.propTypes = {
  ...InputFormField.propTypes,
  rows: PropTypes.number
};

TextAreaFormField.defaultProps = {
  rows: 5
};

export default TextAreaFormField;



// WEBPACK FOOTER //
// ./src/containers/components/text-area-form-field.js